import { render, staticRenderFns } from "./CheckoutCreate.vue?vue&type=template&id=122ca1a4"
import script from "../../controllers/checkout/checkout-create.js?vue&type=script&lang=js&external"
export * from "../../controllers/checkout/checkout-create.js?vue&type=script&lang=js&external"
import style0 from "./CheckoutCreate.vue?vue&type=style&index=0&id=122ca1a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports